import React, { useRef } from "react"
import AgentBrowser from "./AgentBrowser"

function CSAgents() {
  // Use a ref to store the rendered component
  const renderedContent = useRef(null)

  // If the content hasn't been rendered yet, create it
  if (renderedContent.current === null) {
    renderedContent.current = (
      <div className="grid grid-cols-1 gap-4">
        <AgentBrowser />
      </div>
    )
  }

  // Always return the same rendered content
  return renderedContent.current
}

export default CSAgents
